export default __webpack_public_path__ + "static/press-d8f4155dabfda943e3f481ae4994315d.png";